var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5C2.46735 0.5 0 2.96735 0 6C0 9.03265 2.46735 11.5 5.5 11.5C8.53265 11.5 11 9.03265 11 6C11 2.96735 8.53265 0.5 5.5 0.5ZM5.5 10.125C3.22556 10.125 1.375 8.27444 1.375 6C1.375 5.1319 1.63818 4.31124 2.1386 3.61098L7.88902 9.3614C7.18876 9.86182 6.3681 10.125 5.5 10.125ZM8.8614 8.38902L3.11098 2.6386C3.81124 2.13818 4.6319 1.875 5.5 1.875C7.77444 1.875 9.625 3.72556 9.625 6C9.625 6.8681 9.36182 7.68876 8.8614 8.38902Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/StopIcon.cf18457ea5e8aa6ce4fcf8a953c59a28.svg";
export { ForwardRef as ReactComponent };